import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { get } from '@cullylarson/f';
var bgStyles = {
  blue: {
    styles: /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1685866761",
      children: [".jsx-1685866761{background:-webkit-gradient(linear,left top,left bottom,from(#1C357D),to(#182661));background:linear-gradient(#1C357D,#182661);}"]
    }),
    className: "jsx-1685866761"
  },
  gray: {
    styles: /*#__PURE__*/_jsx(_JSXStyle, {
      id: "190987113",
      children: [".jsx-190987113{background:#666C82;}"]
    }),
    className: "jsx-190987113"
  }
};
export default function PartCardListHeading(_ref) {
  var heading = _ref.heading,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? 'blue' : _ref$bg;
  var bgStyle = get(bg, bgStyles.blue, bgStyles);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h2", {
      className: "jsx-3997659083" + " " + (bgStyle.className || ""),
      children: heading
    }), bgStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3997659083",
      children: ["h2.jsx-3997659083{color:white;font-weight:700;-webkit-letter-spacing:0.00625rem;-moz-letter-spacing:0.00625rem;-ms-letter-spacing:0.00625rem;letter-spacing:0.00625rem;padding:7px 20px;font-size:1rem;text-transform:uppercase;}"]
    })]
  });
}